"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeIncomingRoute = void 0;
const url_1 = require("url");
const DEFAULT_IGNORED_ROUTES = (relativeUrl) => relativeUrl.startsWith('/_next/') || relativeUrl.startsWith('/static/');
const DEFAULT_FRAGMENT_PREFIX_BLACKLIST = ['ref=', 'ref%3D'];
const DEFAULT_MAX_FRAGMENT_COUNT = 2;
const sanitizeIncomingRoute = (relativeUrl, options) => {
    var _a, _b;
    const { ignoredRoutes = DEFAULT_IGNORED_ROUTES, fragmentPrefixBlacklist = DEFAULT_FRAGMENT_PREFIX_BLACKLIST, maxFragmentCount = DEFAULT_MAX_FRAGMENT_COUNT } = options !== null && options !== void 0 ? options : {};
    if (ignoredRoutes(relativeUrl)) {
        return relativeUrl;
    }
    const parsedRelativeUrl = (0, url_1.parse)(relativeUrl, true);
    const fragments = ((_a = parsedRelativeUrl.pathname) !== null && _a !== void 0 ? _a : '').split('/');
    const validFragments = [];
    for (const fragment of fragments) {
        if (fragment && fragmentPrefixBlacklist.every((blacklistedPrefix) => !fragment.startsWith(blacklistedPrefix))) {
            validFragments.push(fragment);
        }
    }
    const sanitizedPathName = '/' + validFragments.slice(0, maxFragmentCount).join('/');
    return sanitizedPathName + ((_b = parsedRelativeUrl.search) !== null && _b !== void 0 ? _b : '');
};
exports.sanitizeIncomingRoute = sanitizeIncomingRoute;
